import * as React from 'react';
import { Tooltip } from 'antd';

type Props = {
    text: string;
    maxWidth?: number;
    className?: string;
    style?: React.CSSProperties;
};

const OverflowTooltip: React.FC<Props> = ({ text, maxWidth, className, style }) => {
    const [isOverflown, setIsOverflown] = React.useState(false);
    const textRef = React.useRef<HTMLDivElement>(null);

    React.useLayoutEffect(() => {
        const el = textRef.current;
        if (!el) {
            return;
        }

        const check = () => setIsOverflown(el.scrollWidth > el.clientWidth);
        check();

        const ro = new ResizeObserver(check);
        ro.observe(el);
        return () => ro.disconnect();
    }, [text]);

    return (
        <Tooltip title={isOverflown ? text : undefined}>
            <div
                ref={textRef}
                className={className}
                style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth, ...style }}
            >
                {text}
            </div>
        </Tooltip>
    );
};

export default OverflowTooltip;
